// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"353":"f6702ba0","427":"c738b727","594":"d0bddf0d"}[chunkId] + ".js";
};